module.exports = __webpack_public_path__ + "img/image10.1857f650.png";